import cx from "clsx";
import LogoKreate from "common-utils/logos/LogoKreate";
import Link from "next/link";
import React from "react";

import { Product } from "../../../../types";

import styles from "./index.module.scss";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  product: Product;
};

export default function LinkToProductPageWithKreateLogo({
  className,
  style,
  product,
}: Props) {
  return (
    <div className={cx(styles.container, className)} style={style}>
      <Link
        href={
          product === "art"
            ? "/"
            : product === "market"
            ? "/market"
            : "#disabled"
        }
        className={styles.logo}
      >
        <LogoKreate />
      </Link>
    </div>
  );
}
